<template>
  <div class="col-sm-3 col-md-2 sidebar">
    <ul class="nav nav-sidebar">
      <router-link :tag="'li'" :to="{ name: 'list-versions' }">
        <a href="#">Dashboard </a></router-link
      >
      <router-link :tag="'li'" :to="{ name: 'projects' }">
        <a href="#" data-testid="projects-link-cy">Projects</a>
      </router-link>
      <router-link
        :tag="'li'"
        :to="{ name: 'results' }"
        :class="resultClass"
        v-if="authorProjects.length > 0"
      >
        <a href="#" data-testid="results-link-cy">Results</a>
      </router-link>
      <router-link :tag="'li'" :to="{ name: 'HelpAndSupport' }">
        <a href="#">Help & Support</a>
      </router-link>
      <li v-show="professorKey !== null">
        <a target="_blank" href="/capsiminbox/authoring-platform/courses">My Courses</a>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: 'Sidebar',
    computed: {
      ...mapState('user', ['professorKey', 'isAdmin']),
      ...mapState('versions', ['authorProjects']),
      resultClass() {
        return this.$route.name == 'participant-results' ? 'active' : '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  /*
* Sidebar
*/

  /* Hide for mobile, show later */
  .sidebar {
    display: none;
  }

  @media (min-width: 768px) {
    .sidebar {
      position: fixed;
      top: 51px;
      bottom: 0;
      left: 0;
      z-index: 998;
      display: block;
      padding: 20px;
      overflow-x: hidden;
      overflow-y: auto;
      /* Scrollable contents if viewport is shorter than content. */
      background-color: #6d6e71;
      border-right: 1px solid #eee;
    }
  }

  /* Sidebar navigation */
  .nav-sidebar {
    margin-right: -21px;
    /* 20px padding + 1px border */
    margin-bottom: 20px;
    margin-left: -20px;
  }
  .nav-sidebar > li > a {
    &:hover,
    &:focus {
      background: #47484a;
    }
    font-size: 1.8rem;
    color: white;
    padding-right: 20px;
    padding-left: 20px;
  }
  .nav-sidebar > .active > a,
  .nav-sidebar > .active > a:focus,
  .nav-sidebar > .active > a:hover {
    color: #fff;
    background-color: #47484a;
  }
</style>
